var ErrorService = function (notify) {
    var self = this;

    /**
     * Show an error message passed in, handling specific status codes
     * @param errorMessage {string}
     * @param apiResult
     */
    self.showError = function (errorMessage, apiResult) {
        console.error({
            errorMessage,
            apiResult
        });
        if (apiResult && apiResult.status) {
            switch (apiResult.status) {
                case Dashboard.HttpStatusCodes.Unauthorized:
                    notify.warning('You are not logged in. You will be redirected to a login page to log in and returned once done.', 'User not logged in');
                    return;
                case Dashboard.HttpStatusCodes.NetworkError:
                    if (apiResult.isTimeOut) {
                        notify.error('The request timed out.','Please try again.');
                    }
                    else {
                        notify.error('No Internet Connection.','Please try again.');
                    }
                    return;
            }
        }
        notify.error(errorMessage, 5000);
    }
};

angular.module('dashboard')
    .service('ErrorService', ['notify', ErrorService]);
